import React from "react";
import BtnOnMap from "../BtnOnMap/BtnOnMap";
import SwitchMapIcon from "../Icons/SwitchMapIcon";
import SearchVesselsIcon from "../Icons/SearchVesselIcon";
import TrackerIcon from "../Icons/TrackerIcon";
import MessageIcon from "../Icons/MessageIcon";
import WarningZoneIcon from "../Icons/WarningZoneIcon";
import styles from "./BtnOnMapGroup.module.css";
import { useMapDisplayContext } from "../../contexts/MapDisplayContext";
import { useSidebarContext } from "../../contexts/SidebarContext";
import { useChatContext } from "../../contexts/ChatContext";

const BtnOnMapGroup: React.FC = () => {
  const { mapDisplay, setMapDisplay } = useMapDisplayContext();
  const { openSidebar } = useSidebarContext();
  const { newMessageNotification } = useChatContext();
  const newMessageNotificationRef = React.useRef(newMessageNotification);
  React.useEffect(() => {
    newMessageNotificationRef.current = newMessageNotification;
  }, [newMessageNotification]);
  const handleSwitchMapClick = () => {
    if (mapDisplay === 'windy') setMapDisplay('leaflet');
    else setMapDisplay('windy');
  };
  return (
    <div className={styles["btn-on-map-group"]}>
      <BtnOnMap id="switch-map-btn" text={mapDisplay === 'windy' ? 'Bản đồ thường' : 'Bản đồ với dữ liệu thời tiết'} icon={<SwitchMapIcon />} onClick={handleSwitchMapClick}/>
      <BtnOnMap id="search-vessels-mode-btn" text="Tìm kiếm tàu thuyền" icon={<SearchVesselsIcon />} onClick={()=>openSidebar("searchVessel")}/>
      <BtnOnMap id="tracker-mode-btn" text="Vị trí tàu thuyền" icon={<TrackerIcon />} onClick={()=>openSidebar("tracker")}/>
      <BtnOnMap id="message-mode-btn" text="Tin nhắn" icon={<MessageIcon />} notification={newMessageNotificationRef.current} onClick={() => openSidebar("chatList")}/>
      <BtnOnMap id="warning-zone-mode-btn" text="Vùng cảnh báo" icon={<WarningZoneIcon />} onClick={()=>{openSidebar("warningZoneList")}}/>
    </div>
  );
}

// ...existing code...
export default BtnOnMapGroup;